import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MaterialModule } from "src/app/material.module";
import { CohortsApiService } from "./services/cohorts-api-service";
import { CohortsList } from "./components/list/component";

@NgModule({
    imports: [CommonModule, MaterialModule],
    declarations: [CohortsList],
    providers: [CohortsApiService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [CohortsList],
})

export class CohortsModule {}